import { useLanguage } from 'context/AppContext';
import Dialog from 'components/Dialog';
import { useMemo } from 'react';

type Props = {
  setNames: string[];
  hasImplants: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const TurnaroundOriginEntitiesAlreadyTurnedAroundDialog = ({
  setNames,
  hasImplants,
  onConfirm,
  onCancel,
  ...props
}: Props) => {
  const lang = useLanguage()[0].TurnaroundOriginEntitiesAlreadyTurnedAroundDialog;

  const entityNames = useMemo(() => {
    const entityNames = [...setNames];

    // If implants were turned around, instead of showing their names, group them under 'Sterile Implants'
    if (hasImplants) {
      entityNames.push(lang.sterileImplants);
    }

    return entityNames;
  }, [setNames, hasImplants, lang.sterileImplants]);

  return (
    <Dialog
      open
      title={lang.title({
        entityNames,
      })}
      confirmLabel={lang.confirm}
      cancelLabel={lang.cancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
      {...props}
    />
  );
};
